import { PATH_IMAGES_CDN } from 'src/constants/environment'
import {
  PAYMENT_METHOD_AMEX_ID,
  PAYMENT_METHOD_MASTERCARD_ID,
  PAYMENT_METHOD_VISA_ID,
  PAYMENT_METHOD_CREDITCARD_ID,
  PAYMENT_METHOD_GIROPAY_ID,
  PAYMENT_METHOD_KLARNA_ID,
  PAYMENT_METHOD_IDEAL_ID,
  PAYMENT_METHOD_MULTIBANCO_ID,
  PAYMENT_METHOD_BANCONTACT_ID,
  PAYMENT_METHOD_APPLEPAY_ID,
} from '../PaymentForm/constants'

export const PAYMENT_METHOD_LOGO_WIDTH = 34
export const PAYMENT_METHOD_LOGO_HEIGHT = 24

export const PAYMENT_METHOD_LOGO_SRC_MAPPER = {
  [PAYMENT_METHOD_VISA_ID]: `${PATH_IMAGES_CDN}/210304_visa.svg`,
  [PAYMENT_METHOD_MASTERCARD_ID]: `${PATH_IMAGES_CDN}/210304_mastercard.svg`,
  [PAYMENT_METHOD_AMEX_ID]: `${PATH_IMAGES_CDN}/210304_amex.svg`,
  [PAYMENT_METHOD_CREDITCARD_ID]: `${PATH_IMAGES_CDN}/241127_creditcard.svg`,
  [PAYMENT_METHOD_GIROPAY_ID]: `${PATH_IMAGES_CDN}/210304_giropay.svg`,
  [PAYMENT_METHOD_KLARNA_ID]: `${PATH_IMAGES_CDN}/210805_klarna.svg`,
  [PAYMENT_METHOD_IDEAL_ID]: `${PATH_IMAGES_CDN}/230317_ideal.svg`,
  [PAYMENT_METHOD_MULTIBANCO_ID]: `${PATH_IMAGES_CDN}/230717_multibanco.svg`,
  [PAYMENT_METHOD_BANCONTACT_ID]: `${PATH_IMAGES_CDN}/230928_bancontact.svg`,
  [PAYMENT_METHOD_APPLEPAY_ID]: `${PATH_IMAGES_CDN}/241127_applepay.svg`,
}

export const VALID_PAYMENT_METHOD_IDS = [
  PAYMENT_METHOD_VISA_ID,
  PAYMENT_METHOD_MASTERCARD_ID,
  PAYMENT_METHOD_AMEX_ID,
  PAYMENT_METHOD_CREDITCARD_ID,
  PAYMENT_METHOD_GIROPAY_ID,
  PAYMENT_METHOD_KLARNA_ID,
  PAYMENT_METHOD_IDEAL_ID,
  PAYMENT_METHOD_BANCONTACT_ID,
  PAYMENT_METHOD_MULTIBANCO_ID,
  PAYMENT_METHOD_APPLEPAY_ID,
]
